import MainStore from '../stores/MainStore.js';
import * as Products from './Products.js';
import * as Upsells from './Upsells.js';
import * as Discount from './Discount.js';
import * as ItemCalculate from './ItemCalculate.js';
import * as ShopifyData from './Shopify/Data.js';

export const customInvoice = () => {
  //console.log(MainStore.cart);
  let new_items = [];
  for( let key in MainStore.cart.items ){
    let item = MainStore.cart.items[key];
    //item.variant_id
    new_items.push({
      id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties,
    })
  }
  //console.log(new_items);

  let payload = {payload: new_items};
  //return;
  fetch(window.__config_reactjs_cart.discount_server+'/api/shopify/draft_order_create', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })
  .then(res => res.json())
  .then((result) => {
    setTimeout(function(){ 
      window.location = result.url;
    }, 1000);
  },
  (error) => {
  });
  
};

export const getCart = () => {
  if( window.__env==="development" ){
    MainStore.cart = window.__cart;
    
    //Products.gets(["gid://shopify/Product/8305723474240"]);
    ShopifyData.getProducts(function(){
      Discount.initalItemsDiscountsMap();
      Upsells._adjustUpsellProducts();
    });
  }
  else{
    fetch('/cart.js', {
        method: 'GET'
    })
    .then(res => res.json())
    .then((result) => {
      //console.log(result);
      MainStore.cart = result;
      window.__cart = result;
      
      ShopifyData.getProducts(function(){
        Discount.initalItemsDiscountsMap();
        Upsells._adjustUpsellProducts();
      });
    },
    (error) => {
    });
  }
};

export const hasCustomDiscountItem = () =>{
  let has = false;
  for(let key in window.__cart.items ){
    let item = window.__cart.items[key];
    if( item.properties._custom_discount ){
      has = true;
      break;
    }
  }
  return has;
}

export const _productAdd = (variant_id,qty) =>{
  if( MainStore.submitting ) return;
  MainStore.attemp_fails++;
  if( MainStore.attemp_fails>5 ){
    console.log("Too much fails attemp");
    return;
  }
  //item[item_original.id] = item_original.quantity;
  let data = {
    items: [
      {
        quantity: qty,
        id: variant_id
      }
    ]
  };

  if( window.__config_reactjs_cart.free_item_variant_id===variant_id ){
    data["items"][0]["properties"] = {};
    data["items"][0]["properties"]["_discount"] = 13500;
    data["items"][0]["properties"]["_discount_title"] = "Free bundle";
  }

  MainStore.submitting = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
  .then(res => res.json())
  .then((result) => {
    MainStore.attemp_fails = 0;
    MainStore.submitting = false;
    getCart();
    //MainStore.cart = result;
    //MainStore._cartChange();
  },
  // Note: it's important to handle errors here
  // instead of a catch() block so that we don't swallow
  // exceptions from actual bugs in components.
  (error) => {
    MainStore.submitting = false;
  });
};

export const calculate = () => {
  //console.log(MainStore.cart);
  MainStore.saved = 0;
  MainStore.total = 0;
  MainStore.items = 0;
  MainStore.total_original = 0;
  MainStore.has_wholesale_item = false;
  MainStore.has_discount_item = false;
  MainStore.cart_items_for_checkout = [];
  //console.log(MainStore.cart);
  //if( MainStore.cart===null || typeof MainStore.cart.items==="undefined" ) return;
  if( MainStore.cart===null || typeof MainStore.cart === "undefined" ) return;

  //let discount_rule_applied = [];

  //console.log(MainStore.cart.items);

  //for( let key in MainStore.cart.items ){
  for( let key in window.__cart.items ){
      
    let item = window.__cart.items[key];
    //console.log(item);
    //let variant = Products.getVariantByVariantID(item.variant_id);

    let total = item.final_line_price;

    //if( item.properties?._custom_discount ){
    if( item.properties?._type==="bag size" ){
      let prices = ItemCalculate.ruleBagSize(item);


      //MainStore.total_original += item.original_line_price;
      //total = item.final_line_price;

      MainStore.total_original += prices.original;
      total = prices.final;
      //console.log(prices.saved);
      MainStore.saved += prices.saved;

    }
    else{
      //console.log(item.product_id);
      let variant = Products.getVariantByVariantID(item.variant_id,item.product_id);
      //let product = Products.get(item.product_id);
      if( variant!==null ){
        MainStore.total_original += (item.quantity * variant.compareAtPrice.amount );
        let discount = Discount.get(item);

        if( discount.eligible ){
          MainStore.has_discount_item = true;
        }
        total = Products.itemTotal(item,discount);

        //console.log( ((item.quantity * product.compare_at_price ) - total) );
        MainStore.saved += ((item.quantity * variant.compareAtPrice.amount*100 ) - total);
      }
    }

    //console.log(MainStore.saved);
    

    MainStore.items += item.quantity;


    MainStore.total += total;

    MainStore.cart_items_for_checkout.push({
      id: item.id,
      quantity: item.quantity,
      properties: item.properties,
    });
  }

  //MainStore.saved = MainStore.total_original-MainStore.total;
};

export const _productRemove = (item_original) =>{
  if( MainStore.submitting ) return;
  MainStore.attemp_fails++;
  if( MainStore.attemp_fails>5 ){
    console.log("Too much fails attemp");
    return;
  }
  //console.log( item_original );
  let item = {};
  item.id = item_original.key;
  item.quantity = 0;

  MainStore.submitting = true;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item)
  })
  .then(res => res.json())
  .then((result) => {
    MainStore.attemp_fails = 0;
    MainStore.submitting = false;
    //console.log( result );
    MainStore.cart = result;
    window.__cart = result;
    Upsells._adjustUpsellProducts();
    /*
    if( !tryToAddFreeBundler() ){
      MainStore._cartChange();
    }
    else MainStore._cartChange();
    */

  },
  (error) => {
    MainStore.submitting = false;
  });
}

export const _productUpdate = (item_original) =>{
  if( MainStore.submitting ) return;
  let item = {};
  //item[item_original.id] = item_original.quantity;
  //console.log( typeof item_original.item );
  if( typeof item_original.item !== "undefined" ){
    item.id = item_original.item.key;
  }
  else item.id = item_original.id;
  item.quantity = item_original.quantity;


  item.properties = {...item_original.item.properties};
  let has_discount = Object.keys(item_original.item.properties).includes("_discount");
  //console.log( item.properties );

  if( typeof item.properties["_type"] !== "undefined" && item.properties["_type"]==="bag size" ){
    //Bag size item
    let result = ItemCalculate.ruleBagSize({...item_original.item,...{quantity:item_original.quantity}});
    item.properties["Price/lb"] = result.price;
    //console.log(result);
    //return;
  }
  else{
    /*
    let has_discount = false;
    item.properties = {};
    for( let key in item_original.item.properties ){
      if( key.indexOf("_discount")>-1 ){
        has_discount = true;
        continue;
      }
      item.properties[key] = item_original.item.properties[key];
    }
    */

    let rate_data = window.__discount_object.discountData(item_original.item.product_id, item_original.item.variant_id, window.__discount_object.quantity(item_original.item.handle,item_original.quantity) );
    if( rate_data!==null && rate_data["discount"]>0 ){
      let variant = Products.getVariantByVariantID(item_original.item.variant_id);
      let price = parseFloat(variant.price) * 100;

      item.properties["_discount"] = Math.round(((rate_data["discount"])/100)*price,0);
      item.properties["_discount_break"] = rate_data["quantity"];
      item.properties["_discount_rate"] = rate_data["discount"];
      item.properties["_discount_title"] = "Wholesale "+rate_data["quantity"]+"+";
    }
    else{
      if( has_discount ) item.properties["_discount_adjust"] = "";
    }

    let product = Products.get(item_original.item.product_id);
    if( product!==null && window.__discount_object.isPound( product.handle ) ){
      item.properties["_pound"] = window.__discount_object.quantity(item_original.item.handle,item_original.quantity);
    }
  }
  


  MainStore.submitting = true;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(item)
  })
  .then(res => res.json())
  .then((result) => {
    MainStore.submitting = false;
    //console.log( result );
    MainStore.cart = result;
    window.__cart = result;
    Upsells._adjustUpsellProducts();
  },
  (error) => {
    MainStore.submitting = false;
  });
};

